import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';

import EinsteinIcon from './images/einstein-header-icon.svg';

import './EinsteinCard.scss';

export class EinsteinCard extends Component {
  render() {
    return (
      <div className="header einstein-bg">
        <h1>
          <FormattedMessage id="EinsteinCard.title" />
        </h1>
        <p>
          <FormattedMessage id="EinsteinCard.description" />
        </p>
        <img className="einstein-icon" src={EinsteinIcon} alt="Einstein" />
      </div>
    );
  }
}

EinsteinCard.propTypes = {
  children: PropTypes.element,
  location: PropTypes.object,
  intl: intlShape.isRequired
};

export default injectIntl(EinsteinCard);
